export const CreateIcon = ({ fill = "none", size = 40, stroke = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 4">
        <path
          id="Vector 78"
          d="M17.2041 16.0221V24.7797M11.9231 20.5C16.0478 20.5 18.3604 20.5 22.4852 20.5M8 12V29H26.4837V22.5012L32.8462 23.1154V15.2692L26.4837 16.0221V12C19.2654 12 15.2183 12 8 12Z"
          stroke={stroke}
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
};

export const HelpIcon = ({ size = 20, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
          fill={fill}
        />
        <path d="M11 15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15Z" fill={fill} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 6.25C9.17157 6.25 8.5 6.92157 8.5 7.75V8H6.5V7.75C6.5 5.817 8.067 4.25 10 4.25C11.933 4.25 13.5 5.817 13.5 7.75V7.99264C13.5 8.74279 13.202 9.46221 12.6716 9.99264L11 11.6642V12.25H9V11.25C9 10.9848 9.10536 10.7304 9.29289 10.5429L11.2574 8.57843C11.4127 8.42307 11.5 8.21235 11.5 7.99264V7.75C11.5 6.92157 10.8284 6.25 10 6.25Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const DashboardIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 16V20H4V16H10ZM11 15H3V21H11V15ZM20 4V8H14V4H20ZM21 3H13V9H21V3ZM3 3V13H11V3H3ZM10 12H4V4H10V12ZM13 11V21H21V11H13ZM20 20H14V12H20V20Z"
        fill={fill}
      />
    </svg>
  );
};

export const ContentIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5.99988H3V20.9999H18V19.9999H4V5.99988Z" fill={fill} />
      <path d="M6 2.99988V17.9999H21V2.99988H6ZM11 13.9999V6.99988L17 10.4999L11 13.9999Z" fill={fill} />
    </svg>
  );
};

export const AnalyticsIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 17H7V10H9V17ZM13 7H11V17H13V7ZM17 14H15V17H17V14ZM20 4H4V20H20V4ZM21 3V21H3V3H21Z" fill={fill} />
    </svg>
  );
};

export const CommentsIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 7H16V9H8V7ZM8 13H13V11H8V13ZM5 3V16H15H15.41L15.7 16.29L19 19.59V3H5ZM4 2H20V22L15 17H4V2Z" fill={fill} />
    </svg>
  );
};

export const SubtitlesIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 11H7V13H5V11ZM15 15H5V17H15V15ZM19 15H17V17H19V15ZM19 11H9V13H19V11ZM22 6H2V20H22V6ZM3 7H21V19H3V7Z" fill={fill} />
    </svg>
  );
};

export const CopyrightIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.57 10.96C10.62 10.66 10.72 10.4 10.84 10.17C10.96 9.94 11.15 9.75 11.38 9.61C11.6 9.47 11.87 9.41 12.21 9.4C12.42 9.41 12.61 9.45 12.78 9.52C12.96 9.6 13.13 9.71 13.25 9.85C13.38 9.99 13.48 10.15 13.56 10.33C13.64 10.51 13.68 10.71 13.69 10.91H15.32C15.3 10.48 15.22 10.09 15.06 9.73C14.91 9.37 14.7 9.06 14.42 8.81C14.14 8.56 13.82 8.35 13.44 8.21C13.07 8.06 12.65 8 12.18 8C11.59 8 11.07 8.1 10.63 8.31C10.19 8.52 9.83 8.79 9.54 9.15C9.25 9.5 9.03 9.91 8.89 10.39C8.75 10.87 8.67 11.36 8.67 11.88V12.13C8.67 12.66 8.74 13.15 8.88 13.62C9.02 14.09 9.24 14.5 9.53 14.85C9.82 15.2 10.19 15.48 10.62 15.68C11.06 15.88 11.58 15.99 12.17 15.99C12.6 15.99 13 15.92 13.37 15.78C13.74 15.64 14.07 15.45 14.35 15.21C14.63 14.96 14.86 14.68 15.02 14.35C15.18 14.02 15.28 13.68 15.29 13.3H13.66C13.65 13.49 13.61 13.66 13.52 13.83C13.43 14 13.33 14.13 13.19 14.25C13.05 14.37 12.9 14.46 12.72 14.52C12.55 14.58 12.36 14.6 12.17 14.61C11.84 14.6 11.57 14.54 11.36 14.4C11.13 14.25 10.95 14.06 10.82 13.84C10.69 13.61 10.59 13.34 10.55 13.04C10.51 12.74 10.48 12.43 10.48 12.13V11.88C10.5 11.56 10.52 11.26 10.57 10.96ZM12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
        fill={fill}
      />
    </svg>
  );
};

export const EarnIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 7V10C8 10.55 8.45 11 9 11H15C16.1 11 17 11.9 17 13V17C17 18.1 16.1 19 15 19H13V21H11V19H7V18H15C15.55 18 16 17.55 16 17V13C16 12.45 15.55 12 15 12H9C7.9 12 7 11.1 7 10V7C7 5.9 7.9 5 9 5H11V3H13V5H17V6H9C8.45 6 8 6.45 8 7Z"
        fill={fill}
      />
    </svg>
  );
};

export const CustomisationIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.71 7.2L7.89 5.1L6.71 3L8.81 4.18L10.91 3L9.74 5.1L10.92 7.2L8.82 6.02L6.71 7.2ZM18.9 14.26L16.8 13.08L17.98 15.18L16.8 17.28L18.9 16.1L21 17.28L19.82 15.18L21 13.08L18.9 14.26ZM21 3L18.9 4.18L16.8 3L17.98 5.1L16.8 7.2L18.9 6.02L21 7.2L19.82 5.1L21 3ZM17.14 10.02L6.15 21L3 17.85L14 6.85L17.14 10.02ZM6.15 19.59L13.7 12.04L11.96 10.3L4.41 17.85L6.15 19.59Z"
        fill={fill}
      />
    </svg>
  );
};

export const AudioLibraryIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 6V8H14V13C14 14.1 13.1 15 12 15C10.9 15 10 14.1 10 13C10 11.9 10.9 11 12 11C12.37 11 12.7 11.11 13 11.28V6H16ZM18 20H4V6H3V21H18V20ZM21 3H6V18H21V3ZM7 4H20V17H7V4Z"
        fill={fill}
      />
    </svg>
  );
};

export const SettingsIcon = ({ size = 20, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.2341 0.417801C7.27428 0.176707 7.48287 0 7.72729 0H11.7273C11.9717 0 12.1803 0.176707 12.2205 0.417801L12.6672 3.09828C13.2276 3.33725 13.7527 3.64235 14.2329 4.00368L16.7791 3.04975C17.008 2.964 17.2654 3.0563 17.3876 3.26797L19.3876 6.73208C19.5098 6.94375 19.461 7.21275 19.2723 7.3681L17.1733 9.09607C17.209 9.39259 17.2273 9.69425 17.2273 10C17.2273 10.3058 17.209 10.6075 17.1733 10.904L19.2723 12.632C19.461 12.7873 19.5098 13.0563 19.3875 13.268L17.3875 16.7321C17.2653 16.9437 17.008 17.036 16.7791 16.9503L14.2328 15.9964C13.7527 16.3577 13.2275 16.6628 12.6672 16.9017L12.2205 19.5822C12.1803 19.8233 11.9717 20 11.7273 20H7.72729C7.48287 20 7.27428 19.8233 7.2341 19.5822L6.78735 16.9017C6.22702 16.6628 5.70188 16.3576 5.22172 15.9963L2.67544 16.9502C2.44655 17.036 2.18922 16.9437 2.06702 16.732L0.0670151 13.2679C-0.0551948 13.0563 -0.00646 12.7872 0.182242 12.6319L2.28126 10.9039C2.24561 10.6074 2.22729 10.3057 2.22729 10C2.22729 9.69423 2.24562 9.39255 2.28127 9.09601L0.182266 7.36805C-0.00643681 7.2127 -0.0551717 6.9437 0.0670381 6.73203L2.06704 3.26792C2.18925 3.05625 2.44658 2.96396 2.67546 3.0497L5.22177 4.00364C5.70192 3.64233 6.22704 3.33724 6.78735 3.09828L7.2341 0.417801ZM8.15086 1L7.72767 3.53908C7.69848 3.71427 7.57854 3.86083 7.41258 3.92409C6.76001 4.17285 6.15754 4.52391 5.62484 4.9579C5.48706 5.07016 5.30004 5.10083 5.13362 5.03849L2.72128 4.13474L1.14485 6.86521L3.13293 8.50187C3.2699 8.61462 3.33686 8.79152 3.30889 8.96671C3.25522 9.30292 3.22729 9.64802 3.22729 10C3.22729 10.352 3.25522 10.697 3.30889 11.0332C3.33685 11.2084 3.26989 11.3853 3.13292 11.4981L1.14482 13.1347L2.72126 15.8652L5.13357 14.9615C5.29999 14.8991 5.48701 14.9298 5.62479 15.0421C6.15751 15.4761 6.76 15.8271 7.41258 16.0759C7.57854 16.1392 7.69848 16.2857 7.72768 16.4609L8.15086 19H11.3037L11.7269 16.4609C11.7561 16.2857 11.876 16.1392 12.042 16.0759C12.6946 15.8272 13.297 15.4761 13.8297 15.0421C13.9675 14.9298 14.1545 14.8992 14.321 14.9615L16.7333 15.8653L18.3097 13.1348L16.3217 11.4981C16.1847 11.3854 16.1177 11.2085 16.1457 11.0333C16.1994 10.6971 16.2273 10.352 16.2273 10C16.2273 9.64804 16.1994 9.30296 16.1457 8.96676C16.1177 8.79157 16.1847 8.61468 16.3217 8.50193L18.3098 6.86526L16.7333 4.13479L14.321 5.03852C14.1546 5.10087 13.9676 5.07019 13.8298 4.95794C13.2971 4.52393 12.6946 4.17286 12.042 3.92409C11.876 3.86083 11.7561 3.71427 11.7269 3.53908L11.3037 1H8.15086Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.72729 7.5C8.34658 7.5 7.22729 8.61929 7.22729 10C7.22729 11.3807 8.34658 12.5 9.72729 12.5C11.108 12.5 12.2273 11.3807 12.2273 10C12.2273 8.61929 11.108 7.5 9.72729 7.5ZM6.22729 10C6.22729 8.067 7.7943 6.5 9.72729 6.5C11.6603 6.5 13.2273 8.067 13.2273 10C13.2273 11.933 11.6603 13.5 9.72729 13.5C7.7943 13.5 6.22729 11.933 6.22729 10Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const FeedBackIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 14H11V12H13V14ZM13 5H11V11H13V5ZM19 3H5V19.59L8.29 16.3L8.59 16H9H19V3ZM20 2V17H9L4 22V2H20Z" fill={fill} />
    </svg>
  );
};

export const YourChannelIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 3V21H21V3H3ZM4.99 20C5.38 17.38 7.37 14.9 12 14.9C16.63 14.9 18.62 17.38 19.01 20H4.99ZM9 10C9 8.35 10.35 7 12 7C13.65 7 15 8.35 15 10C15 11.65 13.65 13 12 13C10.35 13 9 11.65 9 10ZM12.72 13.93C14.58 13.59 16 11.96 16 10C16 7.79 14.21 6 12 6C9.79 6 8 7.79 8 10C8 11.96 9.42 13.59 11.28 13.93C6.86 14.18 4.44 16.73 4 19.93V4H20V19.93C19.56 16.73 17.14 14.18 12.72 13.93Z"
        fill={fill}
      />
    </svg>
  );
};

export const YoutubeIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 9.35L15 12L10 14.65V9.35ZM12 6C9.47427 5.95085 6.94814 6.07782 4.44003 6.38C4.18725 6.4509 3.95696 6.58564 3.77132 6.77129C3.58568 6.95693 3.45093 7.18722 3.38003 7.44C3.11214 8.94492 2.98493 10.4715 3.00003 12C2.98493 13.5285 3.11214 15.0551 3.38003 16.56C3.45093 16.8128 3.58568 17.0431 3.77132 17.2287C3.95696 17.4144 4.18725 17.5491 4.44003 17.62C6.94814 17.9222 9.47427 18.0492 12 18C14.5258 18.0492 17.0519 17.9222 19.56 17.62C19.8128 17.5491 20.0431 17.4144 20.2287 17.2287C20.4144 17.0431 20.5491 16.8128 20.62 16.56C20.8879 15.0551 21.0151 13.5285 21 12C21.0151 10.4715 20.8879 8.94492 20.62 7.44C20.5491 7.18722 20.4144 6.95693 20.2287 6.77129C20.0431 6.58564 19.8128 6.4509 19.56 6.38C17.0519 6.07782 14.5258 5.95085 12 6ZM12 5C12 5 18.25 5 19.81 5.42C20.2341 5.53436 20.6208 5.75801 20.9314 6.06861C21.242 6.37921 21.4657 6.76589 21.58 7.19C21.8697 8.77673 22.0103 10.3871 22 12C22.0103 13.6129 21.8697 15.2233 21.58 16.81C21.4657 17.2341 21.242 17.6208 20.9314 17.9314C20.6208 18.242 20.2341 18.4656 19.81 18.58C18.25 19 12 19 12 19C12 19 5.75003 19 4.19003 18.58C3.76592 18.4656 3.37925 18.242 3.06865 17.9314C2.75804 17.6208 2.53439 17.2341 2.42003 16.81C2.13039 15.2233 1.98978 13.6129 2.00003 12C1.98978 10.3871 2.13039 8.77673 2.42003 7.19C2.53439 6.76589 2.75804 6.37921 3.06865 6.06861C3.37925 5.75801 3.76592 5.53436 4.19003 5.42C5.75003 5 12 5 12 5Z"
        fill={fill}
      />
    </svg>
  );
};

export const SwitchAccountIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 20H18V21H3V6H4V20ZM6 3V18H21V3H6ZM8.02 17C8.38 14.87 9.95 12.9 13.5 12.9C17.05 12.9 18.62 14.87 18.98 17H8.02ZM11 8.5C11 7.12 12.12 6 13.5 6C14.88 6 16 7.12 16 8.5C16 9.88 14.88 11 13.5 11C12.12 11 11 9.88 11 8.5ZM14.21 11.93C15.8 11.6 17 10.19 17 8.5C17 6.57 15.43 5 13.5 5C11.57 5 10 6.57 10 8.5C10 10.19 11.2 11.6 12.79 11.93C9.31 12.19 7.39 14.35 7.01 17H7V4H20V17H19.99C19.61 14.35 17.68 12.19 14.21 11.93Z"
        fill={fill}
      />
    </svg>
  );
};

export const SignOutIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 3V21H8V20H19V4H8V3H20ZM11.1 15.1L11.8 15.8L16.2 11.4L11.8 7L11.1 7.7L14.2 10.8H3V11.8H14.3L11.1 15.1Z" fill={fill} />
    </svg>
  );
};

export const AppearanceIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9999 22C10.9299 22 9.86992 21.83 8.83992 21.48L7.41992 21.01L8.83992 20.54C12.5299 19.31 14.9999 15.88 14.9999 12C14.9999 8.12 12.5299 4.69 8.83992 3.47L7.41992 2.99L8.83992 2.52C9.86992 2.17 10.9299 2 11.9999 2C17.5099 2 21.9999 6.49 21.9999 12C21.9999 17.51 17.5099 22 11.9999 22ZM10.5799 20.89C11.0499 20.96 11.5299 21 11.9999 21C16.9599 21 20.9999 16.96 20.9999 12C20.9999 7.04 16.9599 3 11.9999 3C11.5299 3 11.0499 3.04 10.5799 3.11C13.8799 4.81 15.9999 8.21 15.9999 12C15.9999 15.79 13.8799 19.19 10.5799 20.89Z"
        fill={fill}
      />
    </svg>
  );
};

export const UploadVideoIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 18V19H6V18H17ZM6.49 9L7.2 9.71L11 5.91V16H12V5.91L15.8 9.72L16.51 9L11.51 4L6.49 9Z" fill={fill} />
    </svg>
  );
};

export const GoLiveIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 11.9999C14 13.0999 13.1 13.9999 12 13.9999C10.9 13.9999 10 13.0999 10 11.9999C10 10.8999 10.9 9.99992 12 9.99992C13.1 9.99992 14 10.8999 14 11.9999ZM8.48 8.44992L7.77 7.74992C6.68 8.82992 6 10.3399 6 11.9999C6 13.6599 6.68 15.1699 7.77 16.2499L8.48 15.5399C7.57 14.6399 7 13.3899 7 11.9999C7 10.6099 7.57 9.35992 8.48 8.44992ZM16.23 7.74992L15.52 8.45992C16.43 9.35992 17 10.6099 17 11.9999C17 13.3899 16.43 14.6399 15.52 15.5499L16.23 16.2599C17.32 15.1699 18 13.6599 18 11.9999C18 10.3399 17.32 8.82992 16.23 7.74992ZM5.65 5.62992L4.95 4.91992C3.13 6.72992 2 9.23992 2 11.9999C2 14.7599 3.13 17.2699 4.95 19.0799L5.66 18.3699C4.02 16.7399 3 14.4899 3 11.9999C3 9.50992 4.02 7.25992 5.65 5.62992ZM19.05 4.91992L18.34 5.62992C19.98 7.25992 21 9.50992 21 11.9999C21 14.4899 19.98 16.7399 18.35 18.3699L19.06 19.0799C20.87 17.2699 22 14.7599 22 11.9999C22 9.23992 20.87 6.72992 19.05 4.91992Z"
        fill={fill}
      />
    </svg>
  );
};

export const CreatePostIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.01 7.34L16.65 8.98L8.64 17H6.99V15.36L15.01 7.34ZM15.01 5.92L5.99 14.94V18H9.05L18.07 8.98L15.01 5.92ZM17.91 4.43L19.58 6.1L18.91 6.77L17.24 5.1L17.91 4.43ZM17.91 3.02L15.83 5.1L18.92 8.19L21 6.11L17.91 3.02ZM21 10H20V20H4V4H14V3H3V21H21V10Z"
        fill={fill}
        fillOpacity="0.666667"
      />
    </svg>
  );
};

export const NewPlaylistIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 13H18V17H16V13H12V11H16V7H18V11H22V13ZM14 7H2V8H14V7ZM2 12H10V11H2V12ZM2 16H10V15H2V16Z" fill={fill} fillOpacity="0.666667" />
    </svg>
  );
};

export const NewPodcastIcon = ({ size = 24, fill = "white" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 13.66 17.33 15.16 16.23 16.25L15.52 15.54C16.44 14.63 17 13.38 17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 13.38 7.56 14.63 8.47 15.54L7.76 16.25C6.67 15.16 6 13.66 6 12ZM14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 12.74 10.4 13.38 11 13.72V22H13V13.72C13.6 13.38 14 12.74 14 12ZM4.94 19.08L5.65 18.37C4.01 16.74 3 14.49 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 14.49 19.99 16.74 18.35 18.37L19.06 19.08C20.88 17.27 22 14.77 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 14.77 3.12 17.27 4.94 19.08Z"
        fill={fill}
        fillOpacity="0.666667"
      />
    </svg>
  );
};

export const EditStudioIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.06 7.6L16.4 9.94L6.34 20H4V17.66L14.06 7.6ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19ZM17.61 4.05L19.98 6.42L18.84 7.56L16.47 5.19L17.61 4.05ZM17.61 2.63L15.06 5.18L18.85 8.97001L21.4 6.42L17.61 2.63Z"
        fill={fill}
      />
    </svg>
  );
};
export const EditStudioFilledIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19ZM17.61 2.63L15.06 5.18L18.85 8.97001L21.4 6.42L17.61 2.63Z" fill={fill} />
    </svg>
  );
};

export const ThreeDotsVert = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 16.5C12.83 16.5 13.5 17.17 13.5 18C13.5 18.83 12.83 19.5 12 19.5C11.17 19.5 10.5 18.83 10.5 18C10.5 17.17 11.17 16.5 12 16.5ZM10.5 12C10.5 12.83 11.17 13.5 12 13.5C12.83 13.5 13.5 12.83 13.5 12C13.5 11.17 12.83 10.5 12 10.5C11.17 10.5 10.5 11.17 10.5 12ZM10.5 6C10.5 6.83 11.17 7.5 12 7.5C12.83 7.5 13.5 6.83 13.5 6C13.5 5.17 12.83 4.5 12 4.5C11.17 4.5 10.5 5.17 10.5 6Z"
        fill={fill}
      />
    </svg>
  );
};

export const AddRelatedVideoStudio = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 5.87L18.2 12L9 18.13V5.87ZM8 4V20L20 12L8 4Z" fill={fill} />
    </svg>
  );
};

export const GetShareableLinkIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 14.9998C16.06 14.9998 15.23 15.4398 14.68 16.1198L9.74 13.2098C9.9 12.8398 10 12.4298 10 11.9998C10 11.5898 9.92 11.1898 9.76 10.8298L14.71 7.91976C15.26 8.56976 16.08 8.99976 17 8.99976C18.65 8.99976 20 7.64976 20 5.99976C20 4.34976 18.65 2.99976 17 2.99976C15.35 2.99976 14 4.34976 14 5.99976C14 6.36976 14.08 6.72976 14.2 7.05976L9.21 9.98976C8.66 9.38976 7.88 8.99976 7 8.99976C5.35 8.99976 4 10.3498 4 11.9998C4 13.6498 5.35 14.9998 7 14.9998C7.86 14.9998 8.63 14.6298 9.18 14.0498L14.19 16.9898C14.07 17.3098 14 17.6398 14 17.9998C14 19.6498 15.35 20.9998 17 20.9998C18.65 20.9998 20 19.6498 20 17.9998C20 16.3498 18.65 14.9998 17 14.9998ZM17 3.99976C18.1 3.99976 19 4.89976 19 5.99976C19 7.09976 18.1 7.99976 17 7.99976C15.9 7.99976 15 7.09976 15 5.99976C15 4.89976 15.9 3.99976 17 3.99976ZM7 13.9998C5.9 13.9998 5 13.0998 5 11.9998C5 10.8998 5.9 9.99976 7 9.99976C8.1 9.99976 9 10.8998 9 11.9998C9 13.0998 8.1 13.9998 7 13.9998ZM17 19.9998C15.9 19.9998 15 19.0998 15 17.9998C15 16.8998 15.9 15.9998 17 15.9998C18.1 15.9998 19 16.8998 19 17.9998C19 19.0998 18.1 19.9998 17 19.9998Z"
        fill={fill}
      />
    </svg>
  );
};

export const PromoteIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.1945 4L16 6.40726L17.2036 8.00453L20.3982 5.59727L19.1945 4Z" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9L14 5V8.53516C15.1956 9.22678 16 10.5195 16 12.0001C16 13.4806 15.1956 14.7733 14 15.4649V19L8 15H7V19H5V15H2V9H8ZM8.30278 9.99997L13 6.86852V17.1315L8.30278 14H3V9.99997H8.30278Z"
        fill={fill}
      />
      <path d="M18 11H22V13H18V11Z" fill={fill} />
      <path d="M17.2041 16L20.3986 18.4073L19.195 20.0046L16.0005 17.5973L17.2041 16Z" fill={fill} />
    </svg>
  );
};

export const DownloadIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 18V19H6V18H17ZM16.5 11.4L15.8 10.7L12 14.4V4H11V14.4L7.2 10.6L6.5 11.3L11.5 16.3L16.5 11.4Z" fill={fill} />
    </svg>
  );
};

export const DeleteForeverIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 17H9V8H11V17ZM15 8H13V17H15V8ZM19 4V5H18V21H6V5H5V4H9V3H15V4H19ZM17 5H7V20H17V5Z" fill={fill} />
    </svg>
  );
};

export const ArrowBackIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 11V12H5.63997L12.36 18.72L11.65 19.43L3.71997 11.5L11.64 3.58L12.35 4.29L5.63997 11H21Z" fill={fill} />
    </svg>
  );
};

export const EditorStudioIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 4.99982V18.9998H22V4.99982H2ZM21 5.99982V17.9998H3V5.99982H5L6.5 8.99982H9.5L8 5.99982H10L11.5 8.99982H14.5L13 5.99982H15L16.5 8.99982H19.5L18 5.99982H21Z"
        fill={fill}
      />
    </svg>
  );
};

export const ClipsStudioIcon = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 7C8 7.55 7.55 8 7 8C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6C7.55 6 8 6.45 8 7ZM7 16C6.45 16 6 16.45 6 17C6 17.55 6.45 18 7 18C7.55 18 8 17.55 8 17C8 16.45 7.55 16 7 16ZM10.79 8.23L21 18.44V20H17.73L11.97 14.24L10.7 15.51C10.89 15.97 11 16.47 11 17C11 19.21 9.21 21 7 21C4.79 21 3 19.21 3 17C3 14.79 4.79 13 7 13C7.42 13 7.81 13.08 8.19 13.2L9.56 11.83L8.45 10.72C8 10.89 7.51 11 7 11C4.79 11 3 9.21 3 7C3 4.79 4.79 3 7 3C9.21 3 11 4.79 11 7C11 7.43 10.91 7.84 10.79 8.23ZM10.08 8.94L9.65 8.5L9.84 7.92C9.95 7.58 10 7.28 10 7C10 5.35 8.65 4 7 4C5.35 4 4 5.35 4 7C4 8.65 5.35 10 7 10C7.36 10 7.73 9.93 8.09 9.79L8.7 9.55L9.16 10.01L10.27 11.12L10.98 11.83L10.27 12.54L8.9 13.91L8.47 14.34L7.89 14.16C7.55 14.05 7.27 14 7 14C5.35 14 4 15.35 4 17C4 18.65 5.35 20 7 20C8.65 20 10 18.65 10 17C10 16.62 9.93 16.25 9.78 15.88L9.53 15.27L10 14.8L11.27 13.53L11.98 12.82L12.69 13.53L18.15 19H20V18.85L10.08 8.94ZM17.73 4H21V5.56L15.48 11.08L13.07 8.67L17.73 4ZM18.15 5L14.48 8.67L15.48 9.67L20 5.15V5H18.15Z"
        fill={fill}
      />
    </svg>
  );
};

export const UnlistedVisibility = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.78 16H13V15H17.78C19.58 15 21.04 13.43 21.04 11.5C21.04 9.57 19.58 8 17.78 8H13V7H17.78C20.13 7 22.04 9.02 22.04 11.5C22.04 13.98 20.13 16 17.78 16ZM11 15H6.18999C4.38999 15 2.92999 13.43 2.92999 11.5C2.92999 9.57 4.38999 8 6.18999 8H11V7H6.18999C3.83999 7 1.92999 9.02 1.92999 11.5C1.92999 13.98 3.83999 16 6.18999 16H11V15ZM16 11H7.99999V12H16V11Z"
        fill={fill}
      />
    </svg>
  );
};

export const PublicVisibility = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM3 12C3 11.3 3.09 10.63 3.24 9.98L8 14.71V15.5C8 17.26 9.31 18.72 11 18.96V20.94C6.51 20.44 3 16.62 3 12ZM11.5 18C10.12 18 9 16.88 9 15.5V14.29L3.57 8.89C4.84 5.46 8.13 3 12 3C13.05 3 14.06 3.19 15 3.53V5C15 5.55 14.55 6 14 6H11V8C11 8.55 10.55 9 10 9H8V12H14C14.55 12 15 12.45 15 13V17H17C17.55 17 18 17.45 18 18V18.69C16.41 20.12 14.31 21 12 21V18H11.5ZM18.97 17.69C18.82 16.73 18 16 17 16H16V13C16 11.9 15.1 11 14 11H9V10H10C11.1 10 12 9.1 12 8V7H14C15.1 7 16 6.1 16 5V3.95C18.96 5.43 21 8.48 21 12C21 14.16 20.24 16.14 18.97 17.69Z"
        fill={fill}
      />
    </svg>
  );
};

export const PrivateVisibility = ({ fill = "white", size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 8V6.63C17 4.08 14.76 2 12 2C9.24 2 7 4.08 7 6.63V8H4V22H20V8H17ZM8 6.63C8 4.61 9.79 2.97 12 2.97C14.21 2.97 16 4.61 16 6.63V8H8V6.63ZM19 21H5V9H19V21ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z"
        fill={fill}
      />
    </svg>
  );
};
